/**
 * LanguageSwitcher.tsx — Language/Locale Switcher
 * 
 * Delegates to StoreSwitcher since in Magento, languages ARE store views.
 * This is just a semantic alias for clarity in the visual editor.
 */
import React from 'react';
import { StoreSwitcher } from './StoreSwitcher';

interface LanguageSwitcherProps {
  data: {
    [key: string]: unknown;
  };
  styles?: string;
  variant?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = (props) => {
  return <StoreSwitcher {...props} />;
};

export default LanguageSwitcher;
